import React from 'react';
import { LoadingIndicator } from 'components';
import { useFetchAdminManagementUsers } from 'core';
import { t } from '@lingui/macro';
import { AdminExpertisePointUserManagementDataTable, AdminPageTitle } from '../components';

export const AdminUserManagementPage: React.FC = () => {
  const { data: users, isLoading, refetch: refetchUsers } = useFetchAdminManagementUsers();

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <>
      <AdminPageTitle title={t`Kullanıcı Yönetimi`} />
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <AdminExpertisePointUserManagementDataTable users={users || []} refetchUsers={refetchUsers} />
      )}
    </>
  );
};
